import { render, staticRenderFns } from "./communityOrder.vue?vue&type=template&id=1b3e7abe&scoped=true&"
import script from "./communityOrder.vue?vue&type=script&lang=js&"
export * from "./communityOrder.vue?vue&type=script&lang=js&"
import style0 from "./communityOrder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./communityOrder.vue?vue&type=style&index=1&id=1b3e7abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3e7abe",
  null
  
)

export default component.exports